import cx from "classnames";
import { Icon } from "common/Icon";
import { EDIT_TROUTE_MODAL } from "common/modals/EditTRouteModal";
import { commonNouns, commonTRouteMessages, featureNames, fm, Msg, privacyLevels } from "lib/localization";
import { showModal } from "lib/modalUtils";
import { urls } from "lib/urls";
import moment from "moment";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import styles from "./TRouteMeta.scss";

const PRIVACY_LABELS = {
  0: privacyLevels.public,
  1: privacyLevels.private,
  2: privacyLevels.friendsOnly,
};

const PRIVACY_ICONS = {
  0: "md-globe",
  1: "md-eye-off",
  2: "md-contact",
};

const TRouteMetaItem = ({ children, title, i, onClick }) => (
  <div className={cx(styles.TRouteMetaItem, onClick && styles.clickable)} onClick={onClick}>
    <div className={styles.container} data-tip title={title}>
      <div className={styles.icon}>
        <Icon i={i} size={14} />
      </div>
      <div className={styles.text}>{children}</div>
    </div>
  </div>
);

export class TRouteMeta extends React.PureComponent {
  render() {
    const { editable, troute: r, objectType, intl } = this.props;

    return (
      <div className={styles.TRouteMeta}>
        <TRouteMetaItem title={fm(intl, commonTRouteMessages.startLocation)} i="md-pin">
          {r.locality}, {r.administrativeArea}
        </TRouteMetaItem>
        <TRouteMetaItem
          title={fm(intl, commonNouns.visibility)}
          i={PRIVACY_ICONS["" + r.visibility]}
          onClick={editable ? () => showModal(EDIT_TROUTE_MODAL, { troute: r, objectType }) : null}
        >
          <Msg m={PRIVACY_LABELS["" + (r.visibility ?? 0)]} /> ({r.views ?? 0}{" "}
          <T
            id="TRouteMeta.views"
            defaultMessage="{count, plural, =0 {views} one {view} other {views}}"
            values={{ count: r.views }}
          />
          )
        </TRouteMetaItem>
        <TRouteMetaItem title={fm(intl, commonTRouteMessages.dateCreated)} i="md-create">
          <T
            id="TRouteMeta.created"
            defaultMessage="Created {date}"
            values={{ date: moment(r.createdAt).format("MMM D, YYYY") }}
          />
        </TRouteMetaItem>
        {objectType === "route" && (
          <TRouteMetaItem title={fm(intl, commonTRouteMessages.lastUpdated)} i="md-sync">
            <T
              id="TRouteMeta.updated"
              defaultMessage="Updated {date}"
              values={{ date: moment(r.updatedAt).format("MMM D, YYYY") }}
            />
          </TRouteMetaItem>
        )}
        {objectType === "trip" &&
          r.gearId !== 0 &&
          r.gearId && ( // gearId can be zero sometimes?
            <TRouteMetaItem
              title={fm(intl, featureNames.gear)}
              i="md-bicycle"
              onClick={editable ? () => (window.location.href = urls.gear.show(r.gearId)) : null}
            >
              {r.gearName}
            </TRouteMetaItem>
          )}
        {r.copiedFromName && (
          <TRouteMetaItem i="md-link">
            <T
              id="TRouteMeta.copyOf"
              defaultMessage="Copy of {parent}"
              values={{
                parent: (
                  <a data-tip title={r.copiedFromName} href={r.copiedFromPath}>
                    {r.copiedFromName}
                  </a>
                ),
              }}
            />
          </TRouteMetaItem>
        )}
      </div>
    );
  }
}
